import { Button, Input, Select } from 'antd';
import React from 'react';

const ColumnAddModal = ({
  selectedColumnFrom,
  dmnData,
  setSelectedColumn,
  columnList,
  selectedColumnIndex,
  handleAddColumn,
  setShowColumnModal,
  selectedColumn,
  selectedColumnFromType,
  setSelectedColumnFromType,
  headerErrorModal
}: any) => {
  const { Option } = Select;

  return (
    <div>
      {dmnData?.inputFields
        .map((item: any) => item.name)
        ?.includes(selectedColumnFrom) ? (
        <div>
          <h4>Select a Column</h4>
          <div className="modal-container">
            <Select
              className="select-menu dmb-4"
              onChange={(e) => setSelectedColumn(e)}
              placeholder="Select Column to Add"
              showSearch
              value={selectedColumn}
            >
              {columnList.map((column: any) => (
                <Option key={column.name} value={column.name}>
                  {column.name}
                </Option>
              ))}
            </Select>
            <div style={{ color: 'red' }}>{headerErrorModal || ''}</div>
          </div>
          <div className="modal-footer">
            <button
              className={`modal-submit-button ${!selectedColumn ? 'disabled' : ''}`}
              onClick={() => {
                if (selectedColumnIndex !== null) {
                  handleAddColumn(selectedColumnIndex, selectedColumn);
                  
                }
              }}
              disabled={!selectedColumn}
            >
              Submit
            </button>
          </div>
        </div>
      ) : (
        <div>
          <h4>Enter Column Name</h4>
          <Input
            className="input-field-style dmb-4"
            value={selectedColumn}
            style={{ width: '200px' }}
            onChange={(e) => setSelectedColumn(e.target.value)}
          />
           <div style={{ color: 'red' }}>{headerErrorModal || ''}</div>
          <h4>Select Type</h4>
          <Select
            className="select-menu dmb-4"
            defaultValue=""
            value={selectedColumnFromType}
            style={{ width: '20%', marginRight: '10px' }}
            onChange={(e) => setSelectedColumnFromType(e)}
            placeholder='Select Type'
          >
            <Option value="">Select Type</Option>
            <Option value="string">String</Option>
            <Option value="double">Decimal</Option>
          </Select>

          <div className="modal-footer">
            <button
              className={`modal-submit-button ${!selectedColumn || selectedColumnFromType === '' || !selectedColumnFromType ? 'disabled' : ''}`}
              onClick={() => {
                if (selectedColumnIndex !== null) {
                  handleAddColumn(selectedColumnIndex, selectedColumn);
                 
                }
              }}
              disabled={!selectedColumn || selectedColumnFromType === '' || !selectedColumnFromType} // Disable button if values are not set or if selectedColumnFromType is an empty string
            >
              Submit
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ColumnAddModal;
